import PeNpsFeedback from '@polleverywhere/pe-nps-feedback'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import { notify } from '../../components/notification_manager'
import themes from '../../components/theme_picker/themes'

export default async function feedback (state, appOptions, lastPage) {
  let view
  const theme = themes.auto.statusBar()
  const nextPage = lastPage === 'feedback' ? 'home' : lastPage

  if (theme === 'light') {
    view = new PeNpsFeedback()
    view.usrc = state.get('role')
    view.addEventListener('success', () => {
      notify(document.querySelector('pe-application'), {
        title: 'Thank you for responding',
        type: 'success'
      })
    })
    view.addEventListener('close', () => store.dispatch(appSlice.pageUpdated(nextPage)))
  } else {
    store.dispatch(appSlice.pageUpdated('home'))
  }
  return view
}
